import { ReactElement, useState } from 'react'
import styled from 'styled-components'

import IconButton from 'components/v2/IconButton'
import { PanelOpenIcon } from 'components/Icons/PanelOpenIcon'
import { Button } from 'components/v2/Button'
import { CreatePlanModal } from 'features/RoutingProjects/components/CreatePlanModal'
import { IRoutingProjectModel, IRoutingProjectPlan } from 'features/RoutingProjects/types'
import { FormattedMessage } from 'react-intl'
import { RoutingProjectPlanStatus } from 'gql/generated/graphql'
import { usePlanContext } from 'features/RoutingProjects/containers/PlanContainer'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

const TogglePanelWrapper = styled.div`
  margin: -8px 0;
`

const PanelClosedIcon = styled(PanelOpenIcon)`
  transform: rotate(180deg);
`

interface IRoutesListActionsProps {
  isSidebarExpanded: boolean
  setIsSidebarExpanded: (isExpanded: boolean) => void
  routingProjectModel: IRoutingProjectModel
  setSelectedPlan: (plan: IRoutingProjectPlan) => void
  setPlanStatus: (status: RoutingProjectPlanStatus) => void
}

export const RoutingProjectSidebarActions = ({
  isSidebarExpanded,
  setIsSidebarExpanded,
  routingProjectModel,
  setSelectedPlan,
  setPlanStatus
}: IRoutesListActionsProps): ReactElement => {
  const { setHasStartedPlanExport } = usePlanContext()
  const [isOpenCreatePlanModal, setIsOpenCreatePlanModal] = useState(false)

  const handlePlanCreateSuccess = (plan: IRoutingProjectPlan): void => {
    setSelectedPlan(plan)
    setPlanStatus(plan.status)
    setHasStartedPlanExport(false)
  }

  return (
    <>
      <Container>
        <Button kind="cancel" small onClick={(): void => setIsOpenCreatePlanModal(true)}>
          <FormattedMessage id="routingProjects.create.plan.action" defaultMessage="Create Plan" />
        </Button>
        <TogglePanelWrapper onClick={(): void => setIsSidebarExpanded(!isSidebarExpanded)}>
          <IconButton icon={isSidebarExpanded ? <PanelClosedIcon /> : <PanelOpenIcon />} noBorder smallPadding />
        </TogglePanelWrapper>
      </Container>
      {isOpenCreatePlanModal && (
        <CreatePlanModal
          routingProjectModel={routingProjectModel}
          closeModal={(): void => setIsOpenCreatePlanModal(false)}
          onSuccess={(plan): void => handlePlanCreateSuccess(plan)}
        />
      )}
    </>
  )
}
